import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddLetterboxItem from "root/Modals/AddLetterboxItem/ModalAddLetterboxItem";

const useModalAddLetterboxItem = (onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, mode: 'none', child_uid: null, letter_box_item_id: null })  ;

    const onClickActivate = ( mode, child_uid, letter_box_item_id ) =>
    {
        setDialog ({ openState: true, child_uid: child_uid, letter_box_item_id: letter_box_item_id, mode: mode});
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, child_uid: null, letter_box_item_id: null, mode: 'none'});
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, child_uid: null, letter_box_item_id: null, mode: 'none'});

        // Tell the parent we're done
        onSaveCompleted( key ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalAddLetterboxItem child_uid={dialog.child_uid} letter_box_item_id={dialog.letter_box_item_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalAddLetterboxItem ;
